<template>
  <div class="fullSize">
    <v-app-bar class="top-bar">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text icon large v-on="on" class="top-barBtn">
            <v-icon large>menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in menuItems" :key="index" @click="item.click(item)">
            <v-list-item-content>
              <v-list-item-title>{{ item.title_hu }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.hint_hu }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <img src="assets/images/gli_logo.png" class="gliLogoImage" />
      <v-spacer />
      <h3 class="headline mb-0" style="color: #002554">{{ title_hu }}</h3>
      <v-spacer />
      <v-btn icon @click="showHelp" class="top-barBtn">
        <v-icon>help</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer app class="sidepanel" permanent>
      <SidePanel :current-api="currentApi" :map="map" />
    </v-navigation-drawer>
    <v-main class="mapcontent">
      <v-container fluid fill-height class="nopad">
        <div class="map">
          <Map @hasMap="storeMap" />
        </div>
      </v-container>
    </v-main>
  </div>
</template>

<style>
@import './Home.css';
</style>

<script>
import Map from '@/components/Map';
import SidePanel from '@/components/SidePanel';

export default {
  name: 'home',
  data() {
    return {
      currentApi: 'Search',
      map: undefined,
      title: 'Welcome to Hungary Map Platform',
      title_hu: 'Köszöntjük a Hungary Map Platform oldalán',
      menuItems: [
        {
          title: 'Search',
          title_hu: 'Cím keresés',
          hint: 'Search places by address',
          hint_hu: 'Cím szerinti keresés',
          click: this.setApi
        },
        {
          title: 'Reverse Geocode',
          title_hu: 'Keresés koordinátákkal',
          hint: 'Search places by coordinates',
          hint_hu: 'Cím keresés koordináták megadásával',
          click: this.setApi
        },
        {
          title: 'Import',
          title_hu: 'Importálás',
          hint: 'Import data',
          hint_hu: 'Adat importálás',
          click: this.setApi
        },
        {
          title: 'API documentation',
          title_hu: 'API dokumentáció',
          hint: 'Detailed documentation for API usage',
          hint_hu: 'Részletes leírás az API használathoz angol nyelven',
          click: this.setApi
        },
        {
          title: 'Need more?',
          title_hu: 'Többet szeretnél tudni?',
          hint: 'this.contactUrl',
          hint_hu: this.contactUrl(),
          click: this.setApi
        },
        {
          title: 'Back to the GLI HMP page',
          title_hu: 'Vissza a GLI HMP oldalára',
          hint: 'https://www.gli-solutions.com/hu/hmp/',
          hint_hu: 'https://www.gli-solutions.com/hu/hmp/',
          click: () => {
            window.location.href = 'https://www.gli-solutions.com/hu/hmp/';
          }
        }
      ]
    };
  },
  mounted() {},
  methods: {
    showHelp() {
      let help =
        'You can find documentation for API ' +
        '<a href="https://docs.mapbox.com/mapbox-gl-js/api/">here</a><br>' +
        'You can find documentation for Mapbox GL JS ' +
        '<a href="https://docs.mapbox.com/mapbox-gl-js/api/" target="_blank">here</a> ';
      let help_hu =
        'A Mapbox GL JS API dokumentációját ' +
        '<a href="https://docs.mapbox.com/mapbox-gl-js/api/" target="_blank">itt</a> találod';

      let content = {
        html: help_hu ? help_hu : help,
        focusConfirm: false
      };

      this.$swal(content);
    },
    storeMap(map) {
      this.map = map;
    },
    setApi(api) {
      if (api.title === 'Need more?') {
        window.open(this.contactUrl(), '_blank');
      } else if (api.title === 'API documentation') {
        window.open(window.location.origin + window.location.pathname + 'swagger', '_blank');
      } else {
        this.currentApi = api.title;
      }
    },
    contactUrl() {
      return 'https://www.gli-solutions.com/hu/kapcsolat-2/';
    }
  },
  components: {
    Map,
    SidePanel
  }
};
</script>
